
import { useState, useContext, createContext } from "react";

const AppContext = createContext();

const AppProvider = ({ children }) => {
    
    const [navbarData, setNavbarData] = useState([
        {
            id: 1,
            text: "ALL USERS",
            active: true
        },
        {
            id: 2,
            text: "ADD A USER",
            active: false
        },
        {
            id: 3,
            text: "ADD A POST",
            active: false
        },
        {
            id: 4,
            text: "SCHEDULE A POST",
            active: false
        },
        {
            id: 5,
            text: "ALL POSTS",
            active: false
        },
        {
            id: 6,
            text: "SCHEDULE",
            active: false
        },
        {
            id: 7,
            text: "MONTHLY POSTS",
            active: false
        }
    ]);
    const [categorys, setCategorys] = useState([
        {
            id: 0,
            text: "No Category",
            active: false
        },
        {
            id: 1,
            text: "REAL ESTATE",
            active: true
        },
        {
            id: 2,
            text: "LOAN",
            active: false
        },
        {
            id: 3,
            text: "INVESTOR",
            active: false
        },
        {
            id: 4,
            text: "CANADA",
            active: false
        },
        {
            id: 5,
            text: "INSURANCE",
            active: false
        },
        {
            id: 9,
            text: "MEDICARE INSURANCE",
            active: false
        },
        {
            id: 6,
            text: "HEALTH AND LIFE INSURANCE",
            active: false
        },
        {
            id: 7,
            text: "TEAM",
            active: false
        },
        {
            id: 8,
            text: "OTHER",
            active: false
        }
    ]);
    const [profileType] = useState([
        {
            id: 1,
            text: "Facebook"
        },
        {
            id: 2,
            text: "Facebook and Instagram"
        }
    ]);
    const [weekDays, setWeekDays] = useState([
        {
            id: 1,
            text: "Mon",
            name: "Monday",
            active: false,
            postToInstagram: false,
            postToFacebook: false,
            time: ""
        },
        {
            id: 2,
            text: "Tue",
            name:"Tuesday",
            active: false,
            postToInstagram: false,
            postToFacebook: false,
            time: ""
        },
        {
            id: 3,
            text: "Wed",
            name: "Wednesday",
            active: false,
            postToInstagram: false,
            postToFacebook: false,
            time: ""
        },
        {
            id: 4,
            text: "Thu",
            name: "Thursday",
            active: false,
            postToInstagram: false,
            postToFacebook: false,
            time: ""
        },
        {
            id: 5,
            text: "Fri",
            name: "Friday",
            active: false,
            postToInstagram: false,
            postToFacebook: false,
            time: ""
        },
        {
            id: 6,
            text: "Sat",
            name: "Saturday",
            active: false,
            postToInstagram: false,
            postToFacebook: false,
            time: ""
        },
        {
            id: 7,
            text: "Sun",
            name: "Sunday",
            active: false,
            postToInstagram: false,
            postToFacebook: false,
            time: ""
        },
    ])
    const [scheduleCategory, setScheduleCategory] = useState([
        {
            id: 1,
            text: "Client",
        },
        {
            id: 2,
            text: "Category"
        }
    ])
    const [countryData, setCountryData] = useState([
        {
            id: 1,
            country: "USA",
            active: false
        },
        {
            id: 2,
            country: "CANADA",
            active: false
        }
    ]);
    const [allUsers, setAllUsers] = useState([]);
    const [showUsers, setShowUsers] = useState([]);
    const [chunkData, setChunkData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [showFilterBox, setShowFilterBox] = useState(true);
    const [openAddUser, setOpenAddUser] = useState(false);
    const [openDeleteUser, setOpenDeleteUser] = useState(false);
    const [openUserUpdate, setOpenUserUpdate] = useState(false);
    const [openErrorUpdate, setOpenErrorUpdate] = useState(false);
    const [concretUser, setConcretUser] = useState();
    const [openEditUser, setOpenEditUser] = useState(false);
    const [openCompleted, setOpenCompleted] = useState(false);
    const [activeCategory, setActiveCategory] = useState("");
    const [openDeleteSchedule, setOpenDeleteSchedule] = useState(false);
    const [concretSchedule, setConcretSchedule] = useState();
    const [openSubmitPopup, setOpenSubmitPopup] = useState(false);
    const [openMonthlyPosts, setOpenMonthlyPotst] = useState(false);

    return  <AppContext.Provider
                value = {{
                    navbarData, setNavbarData,
                    showFilterBox, setShowFilterBox,
                    categorys, setCategorys,
                    profileType,
                    allUsers, setAllUsers,
                    showUsers, setShowUsers,
                    chunkData, setChunkData,
                    tableData, setTableData,
                    openAddUser, setOpenAddUser,
                    openDeleteUser, setOpenDeleteUser,
                    openEditUser, setOpenEditUser,
                    concretUser, setConcretUser,
                    openCompleted, setOpenCompleted,
                    weekDays, setWeekDays,
                    scheduleCategory, setScheduleCategory,
                    activeCategory, setActiveCategory,
                    openDeleteSchedule, setOpenDeleteSchedule,
                    concretSchedule, setConcretSchedule,
                    openSubmitPopup, setOpenSubmitPopup,
                    openUserUpdate, setOpenUserUpdate,
                    openErrorUpdate, setOpenErrorUpdate,
                    openMonthlyPosts, setOpenMonthlyPotst,
                    countryData, setCountryData
                }}
            > 
                { children }
            </AppContext.Provider>
}

const useGlobalContext = () => {
    return useContext(AppContext);
}

export { AppProvider, useGlobalContext }
